import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeader } from './ui/SectionHeader';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Download',
    desc: 'Get the Protocol and Audio Masterclass instantly to your phone or tablet.'
  }, {
    num: '02',
    title: 'Review',
    desc: 'Listen to the 48-minute audio on your way to Italy or during your first evening.'
  }, {
    num: '03',
    title: 'Execute',
    desc: 'Use the "Respect-First" scripts the moment you step off the plane and watch the country open up for you.'
  }];
  return <section className="py-24 max-w-5xl mx-auto px-6" data-id="element-61">
      <SectionHeader eyebrow="The Process" title="How It Works" centered={true} data-id="element-62" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-16 relative" data-id="element-63">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-gold/30 -z-10" data-id="element-64" />

        {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} direction="up" data-id="element-65">
            <div className="flex flex-col items-center text-center" data-id="element-66">
              <div className="w-24 h-24 rounded-full bg-ivory border-2 border-gold flex items-center justify-center mb-6 shadow-sm" data-id="element-67">
                <span className="font-serif text-3xl text-emerald-900" data-id="element-68">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-serif text-emerald-900 mb-4" data-id="element-69">
                {step.title}
              </h3>
              <p className="text-charcoal/70 font-sans font-light leading-relaxed" data-id="element-70">
                {step.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}